import axios, { AxiosInstance } from 'axios';

import { API_TITASK_URL } from '../config/constants';

const instance: AxiosInstance = axios.create({
  baseURL: API_TITASK_URL,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
  },
});

export default instance;
